import { useMemo } from "react"
import { api } from "~/utils/api"

export type VariantMatch = {
  match: string
  combinedSimilarity: number | null
}

type UseVariantMatchesProps = {
  variantIds: string[]
  enabled?: boolean
}

export type UseVariantMatchesResult = {
  variantMatchesMap?: Map<string, VariantMatch[]>
}

export function useVariantMatches({
  variantIds,
  enabled = true,
}: UseVariantMatchesProps): UseVariantMatchesResult {
  const { data: matchesRaw } = api.npi.getMatchesForVariants.useQuery(
    { variantIds },
    { enabled: enabled && variantIds.length > 0 },
  )

  return useMemo(() => {
    if (!matchesRaw) return {}
    const variantMatchesMap = new Map<string, VariantMatch[]>()
    for (const [variantId, matches] of Object.entries(matchesRaw)) {
      variantMatchesMap.set(variantId, matches)
    }
    return { variantMatchesMap }
  }, [matchesRaw])
}
